export const rxGroupEmptyState_style = {
  rootSx: {},
};
